// These values are use across components/hooks/utils
// It is a bit error prone to (re)define them again and again in each file.
export const DEFAULT_DATE_FORMAT = 'P';
export const DEFAULT_DATE_SERIALIZATION_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_USE_ORDERS_TYPE = 'fund-and-stock'; // 'fund' | 'stock' | 'fund-and-stock'
